import React, { useState, useEffect, useContext } from 'react';
import ControlButtonAdd from './ControlButtonAdd';
import ControlButtonDelete from './ControlButtonDelete';
import ControlButtonUpdate from './ControlButtonUpdate';
import ControlButtonShow from './ControlButtonShow';
import ControlButtonVisibility from './ControlButtonVisibility';
import ControlItem from './ControlItem';
import Pager from './Pager';
import Loading from './Loading';
import SuccessAlert from './SuccessAlert';

import MyProceduresContext from '../context/ProceduresContext';
import MyRequirementsContext from '../context/RequirementsContext';
import MyProcedureClassesContext from '../context/ProcedureClassesContext';

import ModalProcedures from './ModalProcedures';
import ModalItemsDelete from './ModalItemsDelete';
import ModalProceduresAdd from './ModalProceduresAdd';
import ModalProceduresUpdate from './ModalProceduresUpdate';
import ControlButtonEnter from './ControlButtonEnter';

const ControlProducts = ({ setActive }) => {
    const { getProceduresAdmin, procedures, maxPage, setPageAdmin, pageAdmin, error, changeProcedureVisibility, loading, setProcedure, setError, deleteProcedure } = useContext(MyProceduresContext);
    const { setProcedureId, getRequirementsAdmin } = useContext(MyRequirementsContext);
    const { getProcedureClasses } = useContext(MyProcedureClassesContext);

    const [isModalProceduresOpen, setIsModalProceduresOpen] = useState(false);
    const [isModalItemsDeleteOpen, setIsModalItemsDeleteOpen] = useState(false);
    const [isModalProceduresAddOpen, setIsModalProceduresAddOpen] = useState(false);
    const [isModalProceduresUpdateOpen, setIsModalProceduresUpdateOpen] = useState(false);

    const [itemId, setItemId] = useState(null);
    const [successAlert, setSuccessAlert] = useState(null);

    const handleChangeProcedureVisibility = async (procedureId) => {
        const res = await changeProcedureVisibility(procedureId, 2);
        if (res.error) {
            setError({ "error": true, "message": res.response })
            setTimeout(() => {
                setError({ "error": false, "message": "" });
            }, 3000);
        } else {
            setError({ "error": false, "message": "" })
            setSuccessAlert("Visibilidad cambiada correctamente")
            setTimeout(() => {
                setSuccessAlert(null)
            }, 3000);
        }
    }

    useEffect(() => {
        getProceduresAdmin(2);
    }, [pageAdmin]);

    useEffect(() => {
        setPageAdmin(0);
        getProcedureClasses("P");
    }, []);
    return (
        <div className='animation-appear-top-center'>
            <ModalProcedures isModalProceduresOpen={isModalProceduresOpen} setIsModalProceduresOpen={setIsModalProceduresOpen} />
            <ModalItemsDelete isModalItemsDeleteOpen={isModalItemsDeleteOpen} setIsModalItemsDeleteOpen={setIsModalItemsDeleteOpen} setSuccessAlert={setSuccessAlert} loading={loading} deleteFunction={deleteProcedure} itemId={itemId} itemType={2} />
            <ModalProceduresAdd isModalProceduresAddOpen={isModalProceduresAddOpen} setIsModalProceduresAddOpen={setIsModalProceduresAddOpen} setSuccessAlert={setSuccessAlert} itemType={2} />
            <ModalProceduresUpdate isModalProceduresUpdateOpen={isModalProceduresUpdateOpen} setIsModalProceduresUpdateOpen={setIsModalProceduresUpdateOpen} setSuccessAlert={setSuccessAlert} itemType={2} />
            <SuccessAlert isVisible={successAlert} />

            <div className='flex flex-col'>
                <ControlButtonAdd onClick={() => setIsModalProceduresAddOpen(true)} />
                {error.error && <h1 className='text-center text-red-500 w-full my-4'>{error.message}</h1>}
                {procedures && procedures.length > 0 ? procedures.map((procedure, index) => (
                    <ControlItem key={index} title={procedure.procedureTitle} text={procedure.procedureDescription}>
                        <ControlButtonShow onClick={() => { setProcedure(procedure); setProcedureId(procedure.procedureId); setIsModalProceduresOpen(true) }} />
                        <ControlButtonUpdate onClick={() => { setProcedure(procedure); setIsModalProceduresUpdateOpen(true) }} />
                        <ControlButtonVisibility visible={procedure.visible} onClick={() => handleChangeProcedureVisibility(procedure.procedureId)} />
                        <ControlButtonDelete onClick={() => { setItemId(procedure.procedureId); setIsModalItemsDeleteOpen(true) }} />
                        <ControlButtonEnter onClick={() => { setProcedure(procedure); getRequirementsAdmin(procedure.procedureId); setActive("requirementsProducts") }} />
                    </ControlItem>
                )) : <h1 className='text-center w-full font-light my-4'>No hay registros para mostrar</h1>}
                <div>
                    <Loading isLoading={loading} />
                    <div className='flex justify-center mb-4'>
                        <Pager maxPage={maxPage} setPage={setPageAdmin} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ControlProducts;